// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"white\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grain%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);
  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);
  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);
  --card-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);
  --border-radius-sm: 8px;
  --border-radius-md: 12px;
  --border-radius-lg: 20px;
  --border-radius-xl: 30px;
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
  --transition-slow: 0.5s ease;
  --font-primary: "Poppins", "Inter", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, sans-serif;
  --color-text-primary: #1e293b;
  --color-text-secondary: #64748b;
  --color-text-tertiary: #94a3b8;
  --color-bg-primary: #ffffff;
  --color-bg-secondary: #f8fafc;
  --color-bg-tertiary: #f1f5f9;
  --color-border: #e2e8f0;
  --color-primary: #6a11cb;
  --color-secondary: #f857a6;
  --color-success: #00b09b;
  --color-danger: #ff5858;
  --color-warning: #ffd166;
  --color-info: #4facfe;
}

/* Container */
.MaterialVendor-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
  min-height: 100vh;
  font-family: var(--font-primary);
}

/* Header Section */
.MaterialVendor-header {
  background: var(--header-gradient);
  border-radius: var(--border-radius-xl);
  color: white;
  box-shadow: var(--shadow-lg);
  margin-bottom: 2rem;
  position: relative;
  overflow: hidden;
}

.MaterialVendor-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  pointer-events: none;
}

.MaterialVendor-header-content {
  padding: 1rem;
  text-align: center;
  position: relative;
  z-index: 1;
}

.MaterialVendor-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 1rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.MaterialVendor-title-icon {
  font-size: 3rem;
  animation: MaterialVendor-float 3s ease-in-out infinite;
}

.MaterialVendor-subtitle {
  font-size: 1rem;
  opacity: 0.9;
}

.MaterialVendor-stats {
  display: flex;
  justify-content: center;
  gap: 2rem;
}

.MaterialVendor-stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 2rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: var(--border-radius-md);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.MaterialVendor-stat-number {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.MaterialVendor-stat-label {
  font-size: 0.9rem;
  opacity: 0.8;
}

/* Controls Section */
.MaterialVendor-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.MaterialVendor-search-wrapper {
  position: relative;
  flex: 1 1;
  max-width: 400px;
}

.MaterialVendor-search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
  opacity: 0.5;
}

.MaterialVendor-search-input {
  width: 100%;
  padding: 1rem 1rem 1rem 3rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-md);
  font-size: 1rem;
  transition: all var(--transition-fast);
  background: var(--color-bg-primary);
}

.MaterialVendor-search-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
}

.MaterialVendor-add-button {
  padding: 1rem 2rem;
  background: var(--primary-gradient);
  color: white;
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-normal);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
}

.MaterialVendor-add-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.MaterialVendor-add-icon {
  font-size: 1.2rem;
  font-weight: bold;
}

/* Form Modal */
.MaterialVendor-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  animation: MaterialVendor-fadeIn 0.3s ease;
}

.MaterialVendor-form-modal {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-lg);
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  animation: MaterialVendor-slideUp 0.3s ease;
}

.MaterialVendor-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid var(--color-border);
}

.MaterialVendor-form-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: var(--color-text-primary);
}

.MaterialVendor-form-close {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: var(--color-text-secondary);
  transition: color var(--transition-fast);
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.MaterialVendor-form-close:hover {
  color: var(--color-danger);
}

.MaterialVendor-form {
  padding: 2rem;
}

.MaterialVendor-form-group {
  margin-bottom: 1.5rem;
}

.MaterialVendor-form-label {
  display: block;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.MaterialVendor-form-input {
  width: 100%;
  padding: 1rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-md);
  font-size: 1rem;
  transition: all var(--transition-fast);
  background: var(--color-bg-secondary);
}

.MaterialVendor-form-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
  background: var(--color-bg-primary);
}

.MaterialVendor-form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;
}

.MaterialVendor-form-button {
  padding: 1rem 2rem;
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-normal);
}

.MaterialVendor-form-button-cancel {
  background: var(--color-bg-tertiary);
  color: var(--color-text-secondary);
}

.MaterialVendor-form-button-cancel:hover {
  background: var(--color-border);
  transform: translateY(-1px);
}

.MaterialVendor-form-button-submit {
  background: var(--primary-gradient);
  color: white;
}

.MaterialVendor-form-button-submit:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

/* Grid Layout */
.MaterialVendor-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

/* Card Styles */
.MaterialVendor-card {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  overflow: hidden;
  transition: all var(--transition-normal);
  position: relative;
  animation: MaterialVendor-slideUp 0.6s ease-out forwards;
  opacity: 0;
  transform: translateY(30px);
  border: 1px solid var(--color-border);
}

.MaterialVendor-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-lg);
}

.MaterialVendor-card:hover .MaterialVendor-card-overlay {
  opacity: 1;
}

.MaterialVendor-card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--primary-gradient);
  opacity: 0;
  transition: all var(--transition-normal);
  pointer-events: none;
  mix-blend-mode: overlay;
}

.MaterialVendor-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.5rem 0 1.5rem;
}

.MaterialVendor-card-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: var(--success-gradient);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  box-shadow: var(--shadow-sm);
}

.MaterialVendor-card-status {
  padding: 0.5rem 1rem;
  background: var(--success-gradient);
  color: white;
  border-radius: var(--border-radius-xl);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.MaterialVendor-card-content {
  padding: 1rem 1.5rem 1.5rem 1.5rem;
}

.MaterialVendor-card-title {
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0 0 1.5rem 0;
  color: var(--color-text-primary);
  line-height: 1.3;
}

.MaterialVendor-card-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.MaterialVendor-detail-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: var(--color-bg-tertiary);
  border-radius: var(--border-radius-md);
  transition: all var(--transition-fast);
}

.MaterialVendor-detail-item:hover {
  background: var(--color-bg-secondary);
  transform: translateX(5px);
}

.MaterialVendor-detail-icon {
  font-size: 1.2rem;
  opacity: 0.7;
}

.MaterialVendor-detail-content {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.MaterialVendor-detail-label {
  font-size: 0.8rem;
  color: var(--color-text-secondary);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.MaterialVendor-detail-value {
  font-size: 1rem;
  color: var(--color-text-primary);
  font-weight: 600;
}

.MaterialVendor-card-footer {
  padding: 0 1.5rem 1.5rem 1.5rem;
}

.MaterialVendor-card-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.MaterialVendor-action-button {
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all var(--transition-normal);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  position: relative;
  overflow: hidden;
}

.MaterialVendor-action-view {
  background: var(--color-info);
  color: white;
}

.MaterialVendor-action-edit {
  background: var(--color-warning);
  color: white;
}

.MaterialVendor-action-delete {
  background: var(--color-danger);
  color: white;
}

.MaterialVendor-action-button:hover {
  transform: translateY(-3px) scale(1.1);
  box-shadow: var(--shadow-md);
}

.MaterialVendor-action-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left var(--transition-slow);
}

.MaterialVendor-action-button:hover::before {
  left: 100%;
}

/* Loading States */
.MaterialVendor-loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 2rem;
}

.MaterialVendor-loading-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid var(--color-border);
  border-top: 4px solid var(--color-primary);
  border-radius: 50%;
  animation: MaterialVendor-spin 1s linear infinite;
}

.MaterialVendor-loading-text {
  font-size: 1.2rem;
  color: var(--color-text-secondary);
  text-align: center;
}

/* Error States */
.MaterialVendor-error-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 2rem;
  text-align: center;
}

.MaterialVendor-error-icon {
  font-size: 4rem;
}

.MaterialVendor-error-text {
  font-size: 1.2rem;
  color: var(--color-danger);
  max-width: 500px;
}

.MaterialVendor-retry-button {
  padding: 1rem 2rem;
  background: var(--secondary-gradient);
  color: white;
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-normal);
}

.MaterialVendor-retry-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

/* Empty State */
.MaterialVendor-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: 1.5rem;
  text-align: center;
}

.MaterialVendor-empty-icon {
  font-size: 4rem;
  opacity: 0.5;
}

.MaterialVendor-empty-title {
  font-size: 1.5rem;
  color: var(--color-text-primary);
  margin: 0;
}

.MaterialVendor-empty-text {
  font-size: 1rem;
  color: var(--color-text-secondary);
  max-width: 400px;
  margin: 0;
}

.MaterialVendor-empty-button {
  padding: 1rem 2rem;
  background: var(--primary-gradient);
  color: white;
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-normal);
}

.MaterialVendor-empty-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

/* Animations */
@keyframes MaterialVendor-slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes MaterialVendor-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes MaterialVendor-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes MaterialVendor-float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .MaterialVendor-container {
    padding: 1rem;
  }

  .MaterialVendor-title {
    font-size: 2rem;
    flex-direction: column;
    gap: 0.5rem;
  }

  .MaterialVendor-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .MaterialVendor-search-wrapper {
    max-width: none;
  }

  .MaterialVendor-stats {
    flex-direction: column;
    gap: 1rem;
  }

  .MaterialVendor-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .MaterialVendor-form-modal {
    width: 95%;
    margin: 1rem;
  }

  .MaterialVendor-form {
    padding: 1.5rem;
  }

  .MaterialVendor-form-actions {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .MaterialVendor-header-content {
    padding: 1.5rem 1rem;
  }

  .MaterialVendor-title {
    font-size: 1.8rem;
  }

  .MaterialVendor-card-header {
    padding: 1rem 1rem 0 1rem;
  }

  .MaterialVendor-card-content {
    padding: 1rem;
  }

  .MaterialVendor-card-footer {
    padding: 0 1rem 1rem 1rem;
  }

  .MaterialVendor-action-button {
    width: 45px;
    height: 45px;
    font-size: 1.1rem;
  }
}

MaterialVendor-card-footer {
  padding: 0;
  background: var(--color-bg-secondary);
  border-top: 1px solid var(--color-border);
  position: relative;
}

/* Card Actions */
.MaterialVendor-card-actions {
  display: flex;
  padding: 1rem;
  gap: 0.75rem;
  justify-content: center;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.9) 0%,
    rgba(248, 250, 252, 0.9) 100%
  );
}

.MaterialVendor-action-button {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-normal);
  position: relative;
  overflow: hidden;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-height: 44px;
  backdrop-filter: blur(10px);
  border: 1px solid transparent;
}

/* Action Button Variants */
.MaterialVendor-action-view {
  background: var(--success-gradient);
  color: rgb(255, 255, 255);
  /* box-shadow: 0 2px 8px rgba(79, 172, 254, 0.3); */
  border-color: rgba(110, 106, 106, 0.3);
}

.MaterialVendor-action-view:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(79, 172, 254, 0.4);
  border-color: rgba(110, 106, 106, 0.3);
}

.MaterialVendor-action-edit {
  background: rgb(75, 238, 75);
  color: rgb(255, 255, 255);
  /* box-shadow: 0 2px 8px rgba(255, 209, 102, 0.3); */
  border-color: rgba(110, 106, 106, 0.3);
}

.MaterialVendor-action-edit:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(255, 209, 102, 0.4);
  border-color: rgba(255, 255, 255, 0.3);
}

.MaterialVendor-action-delete {
  background: rgb(228, 91, 91);
  color: rgb(255, 255, 255);
  /* box-shadow: 0 2px 8px rgba(255, 88, 88, 0.3); */
  border-color: rgba(110, 106, 106, 0.3);
}

/* .MaterialVendor-action-delete:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(255, 88, 88, 0.4);
  border-color: rgba(255, 255, 255, 0.3);
} */

/* Button Shine Effect */
.MaterialVendor-action-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transition: left var(--transition-slow);
}

.MaterialVendor-action-button:hover::before {
  left: 100%;
}

/* Button Active State */
.MaterialVendor-action-button:active {
  transform: translateY(-1px);
  transition: transform 0.1s ease;
}

/* Action Icon */
.MaterialVendor-action-icon {
  font-size: 1.1rem;
  transition: transform var(--transition-fast);
}

.MaterialVendor-action-button:hover .MaterialVendor-action-icon {
  transform: scale(1.1);
}

/* Action Text */
.MaterialVendor-action-text {
  font-size: 0.8rem;
  font-weight: 700;
}

/* Card Divider */
.MaterialVendor-card-divider {
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    var(--color-border),
    transparent
  );
  margin: 0 1rem;
}

/* Card Meta */
.MaterialVendor-card-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background: var(--color-bg-tertiary);
}

.MaterialVendor-card-timestamp {
  font-size: 0.75rem;
  color: var(--color-text-tertiary);
  font-weight: 500;
}

.MaterialVendor-card-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--success-gradient);
  box-shadow: 0 0 0 2px rgba(0, 176, 155, 0.2);
  animation: MaterialVendor-pulse 2s infinite;
}

/* Hover Effects for Entire Footer */
.MaterialVendor-card:hover .MaterialVendor-card-footer {
  background: var(--color-bg-primary);
}

.MaterialVendor-card:hover .MaterialVendor-card-actions {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(248, 250, 252, 1) 100%
  );
}

.MaterialVendor-card:hover .MaterialVendor-card-meta {
  background: var(--color-bg-secondary);
}

/* Alternative Compact Design */
.MaterialVendor-card-footer.compact {
  padding: 1rem;
}

.MaterialVendor-card-footer.compact .MaterialVendor-card-actions {
  padding: 0;
  gap: 0.5rem;
  background: transparent;
}

.MaterialVendor-card-footer.compact .MaterialVendor-action-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 0;
  min-height: auto;
}

.MaterialVendor-card-footer.compact .MaterialVendor-action-text {
  display: none;
}

.MaterialVendor-card-footer.compact .MaterialVendor-action-icon {
  font-size: 1.2rem;
}

.MaterialVendor-card-footer.compact .MaterialVendor-card-divider,
.MaterialVendor-card-footer.compact .MaterialVendor-card-meta {
  display: none;
}

/* Animations */
@keyframes MaterialVendor-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .MaterialVendor-card-actions {
    flex-direction: column;
    gap: 0.5rem;
  }

  .MaterialVendor-action-button {
    flex: none;
    width: 100%;
  }
}

@media (max-width: 480px) {
  .MaterialVendor-action-button {
    padding: 0.75rem;
    font-size: 0.8rem;
  }

  .MaterialVendor-action-icon {
    font-size: 1rem;
  }

  .MaterialVendor-action-text {
    font-size: 0.75rem;
  }
}

/* Focus States for Accessibility */
.MaterialVendor-action-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.3);
}

.MaterialVendor-action-view:focus {
  box-shadow: 0 0 0 3px rgba(79, 172, 254, 0.3);
}

.MaterialVendor-action-edit:focus {
  box-shadow: 0 0 0 3px rgba(255, 209, 102, 0.3);
}

.MaterialVendor-action-delete:focus {
  box-shadow: 0 0 0 3px rgba(255, 88, 88, 0.3);
}

/* Loading State for Buttons */
.MaterialVendor-action-button.loading {
  pointer-events: none;
  opacity: 0.7;
}

.MaterialVendor-action-button.loading::after {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: MaterialVendor-spin 1s linear infinite;
}

.MaterialVendor-action-button.loading .MaterialVendor-action-icon,
.MaterialVendor-action-button.loading .MaterialVendor-action-text {
  opacity: 0;
}

@keyframes MaterialVendor-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Material/materialVendor.css"],"names":[],"mappings":"AAAA;EACE,qEAAqE;EACrE,uEAAuE;EACvE,qEAAqE;EACrE,oEAAoE;EACpE,kEAAkE;EAClE,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B;kCACgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,kCAAkC;EAClC,sCAAsC;EACtC,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAqX;EACrX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,wCAAwC;EACxC,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,wDAAwD;EACxD,UAAU;EACV,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,UAAU;EACV,wCAAwC;EACxC,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,YAAY;EACZ,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB;;;;GAIC;AACH;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,mCAAmC;EACnC,yBAAyB;EACzB,mDAAmD;EACnD,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,oDAAoD;EACpD,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA;;;;GAIG;;AAEH,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX;;;;;GAKC;EACD,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA,oCAAoC;AACpC;EACE,mCAAmC;AACrC;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,qCAAqC;AACvC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA,eAAe;AACf;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[":root {\n  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);\n  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);\n  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);\n  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);\n  --card-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);\n  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);\n  --border-radius-sm: 8px;\n  --border-radius-md: 12px;\n  --border-radius-lg: 20px;\n  --border-radius-xl: 30px;\n  --transition-fast: 0.2s ease;\n  --transition-normal: 0.3s ease;\n  --transition-slow: 0.5s ease;\n  --font-primary: \"Poppins\", \"Inter\", -apple-system, BlinkMacSystemFont,\n    \"Segoe UI\", Roboto, sans-serif;\n  --color-text-primary: #1e293b;\n  --color-text-secondary: #64748b;\n  --color-text-tertiary: #94a3b8;\n  --color-bg-primary: #ffffff;\n  --color-bg-secondary: #f8fafc;\n  --color-bg-tertiary: #f1f5f9;\n  --color-border: #e2e8f0;\n  --color-primary: #6a11cb;\n  --color-secondary: #f857a6;\n  --color-success: #00b09b;\n  --color-danger: #ff5858;\n  --color-warning: #ffd166;\n  --color-info: #4facfe;\n}\n\n/* Container */\n.MaterialVendor-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 2rem;\n  min-height: 100vh;\n  font-family: var(--font-primary);\n}\n\n/* Header Section */\n.MaterialVendor-header {\n  background: var(--header-gradient);\n  border-radius: var(--border-radius-xl);\n  color: white;\n  box-shadow: var(--shadow-lg);\n  margin-bottom: 2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.MaterialVendor-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"white\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grain)\"/></svg>');\n  pointer-events: none;\n}\n\n.MaterialVendor-header-content {\n  padding: 1rem;\n  text-align: center;\n  position: relative;\n  z-index: 1;\n}\n\n.MaterialVendor-title {\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 1rem 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.MaterialVendor-title-icon {\n  font-size: 3rem;\n  animation: MaterialVendor-float 3s ease-in-out infinite;\n}\n\n.MaterialVendor-subtitle {\n  font-size: 1rem;\n  opacity: 0.9;\n}\n\n.MaterialVendor-stats {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n}\n\n.MaterialVendor-stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem 2rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: var(--border-radius-md);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.MaterialVendor-stat-number {\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n}\n\n.MaterialVendor-stat-label {\n  font-size: 0.9rem;\n  opacity: 0.8;\n}\n\n/* Controls Section */\n.MaterialVendor-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n}\n\n.MaterialVendor-search-wrapper {\n  position: relative;\n  flex: 1;\n  max-width: 400px;\n}\n\n.MaterialVendor-search-icon {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.2rem;\n  opacity: 0.5;\n}\n\n.MaterialVendor-search-input {\n  width: 100%;\n  padding: 1rem 1rem 1rem 3rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-md);\n  font-size: 1rem;\n  transition: all var(--transition-fast);\n  background: var(--color-bg-primary);\n}\n\n.MaterialVendor-search-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n}\n\n.MaterialVendor-add-button {\n  padding: 1rem 2rem;\n  background: var(--primary-gradient);\n  color: white;\n  border: none;\n  border-radius: var(--border-radius-md);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  white-space: nowrap;\n}\n\n.MaterialVendor-add-button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.MaterialVendor-add-icon {\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n/* Form Modal */\n.MaterialVendor-form-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(5px);\n  animation: MaterialVendor-fadeIn 0.3s ease;\n}\n\n.MaterialVendor-form-modal {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: MaterialVendor-slideUp 0.3s ease;\n}\n\n.MaterialVendor-form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.MaterialVendor-form-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n  color: var(--color-text-primary);\n}\n\n.MaterialVendor-form-close {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  color: var(--color-text-secondary);\n  transition: color var(--transition-fast);\n  padding: 0;\n  width: 2rem;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.MaterialVendor-form-close:hover {\n  color: var(--color-danger);\n}\n\n.MaterialVendor-form {\n  padding: 2rem;\n}\n\n.MaterialVendor-form-group {\n  margin-bottom: 1.5rem;\n}\n\n.MaterialVendor-form-label {\n  display: block;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.MaterialVendor-form-input {\n  width: 100%;\n  padding: 1rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-md);\n  font-size: 1rem;\n  transition: all var(--transition-fast);\n  background: var(--color-bg-secondary);\n}\n\n.MaterialVendor-form-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n  background: var(--color-bg-primary);\n}\n\n.MaterialVendor-form-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 2rem;\n}\n\n.MaterialVendor-form-button {\n  padding: 1rem 2rem;\n  border: none;\n  border-radius: var(--border-radius-md);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n}\n\n.MaterialVendor-form-button-cancel {\n  background: var(--color-bg-tertiary);\n  color: var(--color-text-secondary);\n}\n\n.MaterialVendor-form-button-cancel:hover {\n  background: var(--color-border);\n  transform: translateY(-1px);\n}\n\n.MaterialVendor-form-button-submit {\n  background: var(--primary-gradient);\n  color: white;\n}\n\n.MaterialVendor-form-button-submit:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Grid Layout */\n.MaterialVendor-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 2rem;\n  margin-bottom: 3rem;\n}\n\n/* Card Styles */\n.MaterialVendor-card {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n  transition: all var(--transition-normal);\n  position: relative;\n  animation: MaterialVendor-slideUp 0.6s ease-out forwards;\n  opacity: 0;\n  transform: translateY(30px);\n  border: 1px solid var(--color-border);\n}\n\n.MaterialVendor-card:hover {\n  transform: translateY(-8px);\n  box-shadow: var(--shadow-lg);\n}\n\n.MaterialVendor-card:hover .MaterialVendor-card-overlay {\n  opacity: 1;\n}\n\n.MaterialVendor-card-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--primary-gradient);\n  opacity: 0;\n  transition: all var(--transition-normal);\n  pointer-events: none;\n  mix-blend-mode: overlay;\n}\n\n.MaterialVendor-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 1.5rem 0 1.5rem;\n}\n\n.MaterialVendor-card-avatar {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: var(--success-gradient);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: 700;\n  box-shadow: var(--shadow-sm);\n}\n\n.MaterialVendor-card-status {\n  padding: 0.5rem 1rem;\n  background: var(--success-gradient);\n  color: white;\n  border-radius: var(--border-radius-xl);\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.MaterialVendor-card-content {\n  padding: 1rem 1.5rem 1.5rem 1.5rem;\n}\n\n.MaterialVendor-card-title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin: 0 0 1.5rem 0;\n  color: var(--color-text-primary);\n  line-height: 1.3;\n}\n\n.MaterialVendor-card-details {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.MaterialVendor-detail-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: var(--color-bg-tertiary);\n  border-radius: var(--border-radius-md);\n  transition: all var(--transition-fast);\n}\n\n.MaterialVendor-detail-item:hover {\n  background: var(--color-bg-secondary);\n  transform: translateX(5px);\n}\n\n.MaterialVendor-detail-icon {\n  font-size: 1.2rem;\n  opacity: 0.7;\n}\n\n.MaterialVendor-detail-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.MaterialVendor-detail-label {\n  font-size: 0.8rem;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.MaterialVendor-detail-value {\n  font-size: 1rem;\n  color: var(--color-text-primary);\n  font-weight: 600;\n}\n\n.MaterialVendor-card-footer {\n  padding: 0 1.5rem 1.5rem 1.5rem;\n}\n\n.MaterialVendor-card-actions {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n}\n\n.MaterialVendor-action-button {\n  width: 50px;\n  height: 50px;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.MaterialVendor-action-view {\n  background: var(--color-info);\n  color: white;\n}\n\n.MaterialVendor-action-edit {\n  background: var(--color-warning);\n  color: white;\n}\n\n.MaterialVendor-action-delete {\n  background: var(--color-danger);\n  color: white;\n}\n\n.MaterialVendor-action-button:hover {\n  transform: translateY(-3px) scale(1.1);\n  box-shadow: var(--shadow-md);\n}\n\n.MaterialVendor-action-button::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.2),\n    transparent\n  );\n  transition: left var(--transition-slow);\n}\n\n.MaterialVendor-action-button:hover::before {\n  left: 100%;\n}\n\n/* Loading States */\n.MaterialVendor-loading-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  gap: 2rem;\n}\n\n.MaterialVendor-loading-spinner {\n  width: 60px;\n  height: 60px;\n  border: 4px solid var(--color-border);\n  border-top: 4px solid var(--color-primary);\n  border-radius: 50%;\n  animation: MaterialVendor-spin 1s linear infinite;\n}\n\n.MaterialVendor-loading-text {\n  font-size: 1.2rem;\n  color: var(--color-text-secondary);\n  text-align: center;\n}\n\n/* Error States */\n.MaterialVendor-error-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  gap: 2rem;\n  text-align: center;\n}\n\n.MaterialVendor-error-icon {\n  font-size: 4rem;\n}\n\n.MaterialVendor-error-text {\n  font-size: 1.2rem;\n  color: var(--color-danger);\n  max-width: 500px;\n}\n\n.MaterialVendor-retry-button {\n  padding: 1rem 2rem;\n  background: var(--secondary-gradient);\n  color: white;\n  border: none;\n  border-radius: var(--border-radius-md);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n}\n\n.MaterialVendor-retry-button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Empty State */\n.MaterialVendor-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 40vh;\n  gap: 1.5rem;\n  text-align: center;\n}\n\n.MaterialVendor-empty-icon {\n  font-size: 4rem;\n  opacity: 0.5;\n}\n\n.MaterialVendor-empty-title {\n  font-size: 1.5rem;\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n.MaterialVendor-empty-text {\n  font-size: 1rem;\n  color: var(--color-text-secondary);\n  max-width: 400px;\n  margin: 0;\n}\n\n.MaterialVendor-empty-button {\n  padding: 1rem 2rem;\n  background: var(--primary-gradient);\n  color: white;\n  border: none;\n  border-radius: var(--border-radius-md);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n}\n\n.MaterialVendor-empty-button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Animations */\n@keyframes MaterialVendor-slideUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes MaterialVendor-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes MaterialVendor-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes MaterialVendor-float {\n  0%,\n  100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .MaterialVendor-container {\n    padding: 1rem;\n  }\n\n  .MaterialVendor-title {\n    font-size: 2rem;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .MaterialVendor-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .MaterialVendor-search-wrapper {\n    max-width: none;\n  }\n\n  .MaterialVendor-stats {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .MaterialVendor-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .MaterialVendor-form-modal {\n    width: 95%;\n    margin: 1rem;\n  }\n\n  .MaterialVendor-form {\n    padding: 1.5rem;\n  }\n\n  .MaterialVendor-form-actions {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .MaterialVendor-header-content {\n    padding: 1.5rem 1rem;\n  }\n\n  .MaterialVendor-title {\n    font-size: 1.8rem;\n  }\n\n  .MaterialVendor-card-header {\n    padding: 1rem 1rem 0 1rem;\n  }\n\n  .MaterialVendor-card-content {\n    padding: 1rem;\n  }\n\n  .MaterialVendor-card-footer {\n    padding: 0 1rem 1rem 1rem;\n  }\n\n  .MaterialVendor-action-button {\n    width: 45px;\n    height: 45px;\n    font-size: 1.1rem;\n  }\n}\n\nMaterialVendor-card-footer {\n  padding: 0;\n  background: var(--color-bg-secondary);\n  border-top: 1px solid var(--color-border);\n  position: relative;\n}\n\n/* Card Actions */\n.MaterialVendor-card-actions {\n  display: flex;\n  padding: 1rem;\n  gap: 0.75rem;\n  justify-content: center;\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.9) 0%,\n    rgba(248, 250, 252, 0.9) 100%\n  );\n}\n\n.MaterialVendor-action-button {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.875rem 1rem;\n  border: none;\n  border-radius: var(--border-radius-md);\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  position: relative;\n  overflow: hidden;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  min-height: 44px;\n  backdrop-filter: blur(10px);\n  border: 1px solid transparent;\n}\n\n/* Action Button Variants */\n.MaterialVendor-action-view {\n  background: var(--success-gradient);\n  color: rgb(255, 255, 255);\n  /* box-shadow: 0 2px 8px rgba(79, 172, 254, 0.3); */\n  border-color: rgba(110, 106, 106, 0.3);\n}\n\n.MaterialVendor-action-view:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(79, 172, 254, 0.4);\n  border-color: rgba(110, 106, 106, 0.3);\n}\n\n.MaterialVendor-action-edit {\n  background: rgb(75, 238, 75);\n  color: rgb(255, 255, 255);\n  /* box-shadow: 0 2px 8px rgba(255, 209, 102, 0.3); */\n  border-color: rgba(110, 106, 106, 0.3);\n}\n\n.MaterialVendor-action-edit:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(255, 209, 102, 0.4);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.MaterialVendor-action-delete {\n  background: rgb(228, 91, 91);\n  color: rgb(255, 255, 255);\n  /* box-shadow: 0 2px 8px rgba(255, 88, 88, 0.3); */\n  border-color: rgba(110, 106, 106, 0.3);\n}\n\n/* .MaterialVendor-action-delete:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(255, 88, 88, 0.4);\n  border-color: rgba(255, 255, 255, 0.3);\n} */\n\n/* Button Shine Effect */\n.MaterialVendor-action-button::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.3),\n    transparent\n  );\n  transition: left var(--transition-slow);\n}\n\n.MaterialVendor-action-button:hover::before {\n  left: 100%;\n}\n\n/* Button Active State */\n.MaterialVendor-action-button:active {\n  transform: translateY(-1px);\n  transition: transform 0.1s ease;\n}\n\n/* Action Icon */\n.MaterialVendor-action-icon {\n  font-size: 1.1rem;\n  transition: transform var(--transition-fast);\n}\n\n.MaterialVendor-action-button:hover .MaterialVendor-action-icon {\n  transform: scale(1.1);\n}\n\n/* Action Text */\n.MaterialVendor-action-text {\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n/* Card Divider */\n.MaterialVendor-card-divider {\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    var(--color-border),\n    transparent\n  );\n  margin: 0 1rem;\n}\n\n/* Card Meta */\n.MaterialVendor-card-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1rem;\n  background: var(--color-bg-tertiary);\n}\n\n.MaterialVendor-card-timestamp {\n  font-size: 0.75rem;\n  color: var(--color-text-tertiary);\n  font-weight: 500;\n}\n\n.MaterialVendor-card-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--success-gradient);\n  box-shadow: 0 0 0 2px rgba(0, 176, 155, 0.2);\n  animation: MaterialVendor-pulse 2s infinite;\n}\n\n/* Hover Effects for Entire Footer */\n.MaterialVendor-card:hover .MaterialVendor-card-footer {\n  background: var(--color-bg-primary);\n}\n\n.MaterialVendor-card:hover .MaterialVendor-card-actions {\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 1) 0%,\n    rgba(248, 250, 252, 1) 100%\n  );\n}\n\n.MaterialVendor-card:hover .MaterialVendor-card-meta {\n  background: var(--color-bg-secondary);\n}\n\n/* Alternative Compact Design */\n.MaterialVendor-card-footer.compact {\n  padding: 1rem;\n}\n\n.MaterialVendor-card-footer.compact .MaterialVendor-card-actions {\n  padding: 0;\n  gap: 0.5rem;\n  background: transparent;\n}\n\n.MaterialVendor-card-footer.compact .MaterialVendor-action-button {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  padding: 0;\n  min-height: auto;\n}\n\n.MaterialVendor-card-footer.compact .MaterialVendor-action-text {\n  display: none;\n}\n\n.MaterialVendor-card-footer.compact .MaterialVendor-action-icon {\n  font-size: 1.2rem;\n}\n\n.MaterialVendor-card-footer.compact .MaterialVendor-card-divider,\n.MaterialVendor-card-footer.compact .MaterialVendor-card-meta {\n  display: none;\n}\n\n/* Animations */\n@keyframes MaterialVendor-pulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scale(1.1);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .MaterialVendor-card-actions {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .MaterialVendor-action-button {\n    flex: none;\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .MaterialVendor-action-button {\n    padding: 0.75rem;\n    font-size: 0.8rem;\n  }\n\n  .MaterialVendor-action-icon {\n    font-size: 1rem;\n  }\n\n  .MaterialVendor-action-text {\n    font-size: 0.75rem;\n  }\n}\n\n/* Focus States for Accessibility */\n.MaterialVendor-action-button:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.3);\n}\n\n.MaterialVendor-action-view:focus {\n  box-shadow: 0 0 0 3px rgba(79, 172, 254, 0.3);\n}\n\n.MaterialVendor-action-edit:focus {\n  box-shadow: 0 0 0 3px rgba(255, 209, 102, 0.3);\n}\n\n.MaterialVendor-action-delete:focus {\n  box-shadow: 0 0 0 3px rgba(255, 88, 88, 0.3);\n}\n\n/* Loading State for Buttons */\n.MaterialVendor-action-button.loading {\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n.MaterialVendor-action-button.loading::after {\n  content: \"\";\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: MaterialVendor-spin 1s linear infinite;\n}\n\n.MaterialVendor-action-button.loading .MaterialVendor-action-icon,\n.MaterialVendor-action-button.loading .MaterialVendor-action-text {\n  opacity: 0;\n}\n\n@keyframes MaterialVendor-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
